import {ref,h} from "vue"
import { defineStore } from 'pinia';
import Cookies from 'js-cookie';
import { Modal,Button } from 'winbox-ui-next';
import { Session, Local } from '/@common/utils/storage';
import {isRequireNoticeVersionUpdate} from '/@common/api/index';
import { useLoginApi } from '/@/api/login';
import router from '../router';
import { useRoute } from 'vue-router';
import { UrlSearch } from '/@common/utils/utils.ts';
import { useBasicLayout } from '/@common/hooks/useBasicLayout';
import {i18n} from "/@common/i18n";
import { useChatStore } from '/@/stores/chat';
import { useRoleConfig } from '/@/stores/role';
const { t } = i18n.global;
const route = useRoute();
const { isMobile } = useBasicLayout();
const { isLoginExpiredApi, logout, loginOutMobile, isLoginApi, getInfoLogin,getUserOperationPermissions,getUserDetail} = useLoginApi();
const time=ref(5)
const model=ref()
const loginModel=ref()
const chatStore = useChatStore();
const roleConfig = useRoleConfig();
/**
 * 用户信息
 * @methods setUserInfos 设置用户信息
 */
export const useUserInfo = defineStore('userInfo', {
	state: (): UserInfosState => ({
		loginUrl: '/admin',
		isLoginState:true,
		userInfos: {
			userName: '',
			vipType:'0',
			firstLogin: false,
			photo: '',
			time: 0,
			roles: [],
			authBtnList: [],
			isLoginExpired: false,
			userNumber: '',
			timer: null,
			havePwd:1,
			lastToken:"",
			docChat:false,
			generateImage: false,
			userId:'',
			role:0,
			headImg:'',
			name:'',
			isLitAvailable:0
		},
		setPwd:false,
		loginInfo:false,
		loginTimer:null,
		isVersionTip:false,
		showModelVersionTip:false,
		tipTimer:null,
		versionData:{},
		chatTimer:null
	}),
	actions: {
		setPwdStatus(data:boolean){
			this.setPwd=data

		},
		setHavePwd(data:number){
			this.userInfos.havePwd=data
	 },
		setLoginInfo(data:boolean){
			this.loginInfo=data
		},
		async setUserInfos() {
			const token = Session.get('token');
	        const tokenKey = Cookies.get('TOKEN_KEY');
			// 存储用户信息到浏览器缓存
			if (Session.get('userInfo')) {
				this.userInfos = Session.get('userInfo');
			} else {
				const userInfos: any = await this.getApiUserInfo();			
				this.userInfos = userInfos;
			}
			if(token&&tokenKey){
				this.getUserDetailsSetVTip()
			}
			//查询权限相关接口
			const permission=await this.getApiUserPermissions();
			if(permission){
				Session.set('docChat', permission.docChat || false);
				this.userInfos.docChat=permission.docChat
				this.userInfos.generateImage=permission.generateImage
			}
		},
		//AI绘画，长文档权限
		async getApiUserPermissions() {
			const res: any = await getUserOperationPermissions();
			return res.code == 200? res.data:'';
			
		},
		async getUserDetailsSetVTip() {
			const token = Session.get('token');
		    let tokenKey = Cookies.get('TOKEN_KEY');
			if(token&&tokenKey&&token==tokenKey){
				const res: any = await getUserDetail();
				if(res?.code==200){
					this.userInfos.vipType=res.data?.vipType
					this.userInfos.role=res.data?.role
					this.userInfos.headImg=res?.data?.headImg
					this.userInfos.userName=res?.data?.name
					this.userInfos.roles[0]=res?.data?.role==1?'admin':'common'
					this.userInfos.isLitAvailable=res?.data?.isLitAvailable
					Session.set('userName', res?.data?.name);
				}
			
				// let res = await isLoginExpiredApi()
				// if(res?.code == 200&&!res.data){
				// 	const res: any = await getUserDetail();
				// 	if(res?.code==200){
				// 		this.userInfos.vipType=res.data?.vipType
				// 		this.userInfos.role=res.data?.role
				// 		this.userInfos.headImg=res?.data?.headImg
				// 		this.userInfos.userName=res?.data?.name
				// 		this.userInfos.roles[0]=res?.data?.role==1?'admin':'common'
				// 		Session.set('userName', res?.data?.name);
				// 	}
				// }
			}
		
		},
		
		// 模拟接口数据
		async getApiUserInfo() {
			return new Promise((resolve) => {
				setTimeout(() => {
					// 模拟数据，请求接口时，记得删除多余代码及对应依赖的引入
					const vipType = Cookies.get('vipType') || 0;
					const userName = Cookies.get('userName');
					const userId = Cookies.get('userId');
					const userNumber = Cookies.get('userNumber');
					const phoneNumber = Cookies.get('phoneNumber');
					const firstLogin = Cookies.get('firstLogin');
					const havePwd = Cookies.get('havePwd');
					// 模拟数据
					let defaultRoles: Array<string> = [];
					let defaultAuthBtnList: Array<string> = [];
					// admin 页面权限标识，对应路由 meta.roles，用于控制路由的显示/隐藏
					let adminRoles: Array<string> = ['admin'];
					// admin 按钮权限标识
					// let adminAuthBtnList: Array<string> = ['btn.add', 'btn.del', 'btn.edit', 'btn.link'];
					// test 页面权限标识，对应路由 meta.roles，用于控制路由的显示/隐藏
					let testRoles: Array<string> = ['common'];
					// test 按钮权限标识
					// let testAuthBtnList: Array<string> = ['btn.add', 'btn.link'];
					// 不同用户模拟不同的用户权限
					if (Session.get('role') == 1) {
						defaultRoles = adminRoles;
						// defaultAuthBtnList = adminAuthBtnList;
					} else {
						defaultRoles = testRoles;
						// defaultAuthBtnList = testAuthBtnList;
					}
					// 用户信息模拟数据
					const userInfos = {
						vipType: vipType,
						userName: userName,
						firstLogin: firstLogin,
						userNumber: userNumber,
						havePwd: havePwd,
						userId,
						photo: userName === 'admin' ? '' : '',
						time: new Date().getTime(),
						roles: defaultRoles,
						authBtnList: defaultAuthBtnList,
						phoneNumber:phoneNumber
					};
					resolve(userInfos);
				}, 0);
			});
		},
		async isTipsFun(){
			let res = await isRequireNoticeVersionUpdate();
			if (res) {
				if(res?.code == 200 && res?.data){
					if(res.data.requireNotice){
						if(chatStore.dialogueLoading){
							this.chargeChatLoading(res.data)
							return
						}
						this.isVersionTip=true
						this.versionData=res.data
					}
				}
			}
		},
		chargeChatLoading(data:object){
			this.chatTimer=setInterval(() => {
				if(!chatStore.dialogueLoading){
					clearInterval(this.tipTimer);
					this.isVersionTip=true
					this.versionData=data
				}
			}, 1000);
		},
		tipsVersionSerach(){
			this.isTipsFun();
			this.tipTimer=setInterval(() => {
				this.isTipsFun();
			}, 1000 * 60*3);
		},
		clearTipsSeach() {
			if(this.tipTimer){
				clearInterval(this.tipTimer);
			}
			
		},
		async isLoginExpiredFun() {
			let res = await isLoginExpiredApi();
			if (res.code == 200 && res.data) {
				this.ModalTip();
			}
		},
		loginExpiredSeach() {
			if(Session.get('phoneNumber')=='bind'){
				this.clearLoginExpiredSeach()
			}else{
				this.userInfos.timer = setInterval(() => {
					this.isLoginExpiredFun();
				}, 1000 * 30);
			}
			
		},
		clearLoginExpiredSeach() {
			clearInterval(this.userInfos.timer);
		},
		closeModel(){
			model.value.close()
		},
		closeLoginModel(){
			loginModel.value.close()
		},
		ModalTip() {
			this.clearTipsSeach()
			this.clearLoginExpiredSeach();
			if (window.location.hash.indexOf('/h5/') != -1) {
				Session.clear();
				window.location.reload();
			} else {
				if (Session.get('token')) {
					this.isLoginState = true;
					Session.clear();
					window.location.reload();
				} else {
					console.log('未登录设置弹窗');
					if (this.isLoginState) {
						this.loginUrl = '/admin/';
						this.isLoginState = false;
					}
				}
				// roleConfig.currentRole = roleConfig.roleList[0].roleId
				// this.loginUrl =  '/admin';
				// this.isLoginState = false;
				
				// loginModel.value=Modal.warning({
				// 	title: i18n.global.t('chat.store.loginInvalidation'),
				// 	content: i18n.global.t('chat.store.loginAgainContent'),
				// 	closable: false,
				// 	maskClosable: false,
				// 	okText: i18n.global.t('chat.store.loginAgainBtn'),
				// 	modalClass: 'warningLoginModal',
				// 	width: '480px',
				// 	onOk: () => {
				// 		Session.clear();
				// 		window.location.reload();
				// 	},
				// });
			}
		},
		setSession(res:any,url:string,type?:string) {	
			let phoneNumber=res?.data?.phoneNumber||''
			if(!phoneNumber){
				phoneNumber='bind'
			}
			console.log('res?.dat给phone信息',res?.data,)
			console.log("加日志code接口返回手机号码===",res?.data?.phoneNumber)
			// console.dir(res?.data)
			// console.table(res?.data)
			Session.set('token', res?.data.token);
			Session.set('userName', res?.data.name);
			Session.set('userId', res?.data.id);
			Session.set('yayiFlag', res?.data.yayiFlag);
			Session.set('cvFlag', res?.data.cvFlag);
			Session.set('vipType', res?.data.vipType || 0);
			Session.set('docChat', res?.data.vipType || false);
			Session.set('role', res?.data.role);
			Session.set('userNumber', res?.data.phoneNumber);
			Session.set('firstLogin', res?.data.firstLogin);
			Session.set('firstPay', res?.data.firstPay);
			Session.set('phoneMd5', res?.data.phoneMd5);
			Session.set('bindInfo', res?.data.bindInfo ?? '');
			Session.set('havePwd', res?.data.havePwd);
			Session.set('phoneNumber', phoneNumber);
			Session.set('wechatUserId', res?.data.wechatUserId);
			if (type == 'third') {
				Session.set('TOKEN_KEY', res?.data.token);

			}
			this.userInfos.vipType = res?.data.vipType
			this.setUserInfos()
			console.log(url,phoneNumber,'chat信息接口判断')
			if(phoneNumber=='bind'){
				//打开绑定弹窗
				console.log("ooooooo没有绑定手机号")
				this.isLoginState=false
				localStorage.removeItem('loginType');
				return
			}
			if(url&&phoneNumber&&phoneNumber!='bind'){		
				 if(localStorage.getItem('loginType')=='weixin'&&localStorage.getItem('nowLink')){
				 }else{
					console.log("移除link")
					localStorage.removeItem('nowLink')
					localStorage.removeItem('loginType')
				 }
				 
			}else{
				console.log("到首页")
				localStorage.removeItem('phoneNumber')
				// router.push('/');
				setTimeout(()=>{
					window.location.reload();
				},200)
				
			}
		},
		async getUrlTicket(ticket:string) {
			let url=localStorage.getItem('nowLink')
			getInfoLogin(ticket).then((res) => {
				if (res.code == 200) {
					this.setSession(res,url,'third')
					return 
				}
			});
		},
		async isLogin() {
			let data = {
				callback_uri: import.meta.env.DEV
					? `${import.meta.env.VITE_SERVER_TARGET}${import.meta.env.VITE_APP_NAME}`
					: `${window.location.origin}${window.location.pathname}`,
				client_id: `yayi-${import.meta.env.VITE_APP_NAME}`,
				state: 'null',
			};
			console.log(localStorage.getItem('nowLink'),"nowLink")
			let url=localStorage.getItem('nowLink')
			let res = await isLoginApi(data);
			if (res.code == 200) {
				const obj = UrlSearch(res?.data);
				if (obj.redirect) {
					let redirectUrl = decodeURIComponent(obj.redirect);
					const obj1 = UrlSearch(redirectUrl);
					getInfoLogin(obj1.ticket).then((res) => {
						if (res.code == 200) {
							this.setSession(res,url)
							return 
						}
					});
				} else {
					console.dir(obj)
					console.log("没有url",url)
					this.loginUrl = import.meta.env.DEV ? res?.data.replace(import.meta.env.VITE_SERVER_TARGET, '/') : res?.data;
					this.isLoginState = false;
							if(url){
								 localStorage.removeItem('nowLink')
							}else{
								router.push('/chat/21');
							}
					return 
					// window.location.href = import.meta.env.DEV ? res?.data.replace(import.meta.env.VITE_SERVER_TARGET, '/') : res?.data;
				}
			} else {
				Cookies.remove('TOKEN_KEY', {path: '/'});
				window.location.reload();
				return 
			}
		},
		clearLoginInfo(){
			clearInterval(this.loginTimer)
		},
		async openModel(){
			time.value=5
			this.loginModalTip()
			this.loginTimer =await setInterval(() => {
			time.value-=1
			if(time.value==1){
			this.handleOk()
			}
		}, 1000 );
		},
		handleOk() {
			Cookies.remove('lastToken'); 
			Cookies.remove('lastUserId'); 
			this.clearLoginInfo();
			window.location.reload()
		},
		loginModalTip(){
			model.value=Modal.warning({
				title: t('admin.user.loginReset'),
				content: 
				() => {
          return h('div', [h('span',t('admin.user.loginInfo',{second:time.value}))]);
        },
				closable: false,
				maskClosable: false,
				footer:	() => {
          return h('div', [h(Button,{class:['okBtn'],onClick: () => {this.handleOk()} },t('admin.user.timeInfo',{second:time.value}))]);
        },
				modalClass:'warningLoginModal',
				width: '480px',
				
			});
			
		},
		clearLoginMessage(){
			this.clearTipsSeach()
			this.clearLoginExpiredSeach();
			localStorage.removeItem('phoneNumber')
			Session.clear();
		},
		async logout() {
			let params = {
				accessToken: Session.get('token'),
				clientId: 'yayi-chat',
				callbackUri: import.meta.env.DEV
					? `${import.meta.env.VITE_SERVER_TARGET}${import.meta.env.VITE_APP_NAME}`
					: `${window.location.origin}${window.location.pathname}`,
			};
			// //oldCode 不进行删除
			// const tokenKey = Cookies.get('TOKEN_KEY');
			// const userId = Session.get('userId');
			// Session.set('lastToken',tokenKey)
			// Session.set('lastUserId',userId)
			let res = await logout(params);
			if (res.code == 200) {
				this.clearLoginMessage()
				this.loginUrl = import.meta.env.DEV ? res?.data.replace(import.meta.env.VITE_SERVER_TARGET, '/') : res?.data;
				this.isLoginState = false;
				// window.location.href = import.meta.env.DEV ? res?.data.replace(import.meta.env.VITE_SERVER_TARGET, '/') : res?.data;
			}
		},
		async loginOutMobile() {
			let res = await loginOutMobile();
			Session.clear();
			if (res.code == 200) {
				if (window.plus) {
					plus.runtime.restart();
				} else {
					router.push('/login');
				}
			}
		},
	},
});
